import { TransactionState } from '@app/store/domain';

export type Space = {
  id: string;
  externalId: string;
  name: string;
  membersCount: number;
};

export type PageInfo = {
  hasNextPage: boolean;
  endCursor?: string | null;
};

export type CreateSpaceFormError = {
  field: 'name' | 'root';
  message: string;
};

export type CreateSpaceFormState = {
  isModalOpen: boolean;
  name: string;
  isSubmitting: boolean;
  errors: CreateSpaceFormError[];
};

export type RenameSpaceStatus = 'idle' | 'processing' | 'success' | 'failed';

export type RenameSpaceError = {
  field: 'name';
  message: string;
};

export type State = {
  spaces: Space[];
  pageInfo: PageInfo;
  searchQuery: string;
  createSpaceForm: CreateSpaceFormState;
  spaceToRename: Space | null;
  renameSpaceStatus: RenameSpaceStatus;
  renameSpaceError: RenameSpaceError | null;
  error: {
    message: string;
  };
} & TransactionState;

export const defaultCreateSpaceFormState: CreateSpaceFormState = {
  isModalOpen: false,
  name: '',
  isSubmitting: false,
  errors: [],
};

export const defaultState: State = {
  status: 'idle',
  spaces: [],
  pageInfo: {
    hasNextPage: false,
    endCursor: null,
  },
  searchQuery: '',
  createSpaceForm: defaultCreateSpaceFormState,
  spaceToRename: null,
  renameSpaceStatus: 'idle',
  renameSpaceError: null,
  error: {
    message: '',
  },
};
